/** Only aggregate performance values: never element text, URLs, query strings or DOM attribution. */
export function webVitalProperties(metric: { name: string; value: number; delta: number; id: string; rating: string }, pageType: string) {
  if (!["LCP", "INP", "CLS"].includes(metric.name) || !Number.isFinite(metric.value) || metric.value < 0 || !Number.isFinite(metric.delta)) return null;
  return { metric_name: metric.name, metric_value: metric.value, metric_delta: metric.delta,
    metric_id: metric.id, metric_rating: metric.rating, page_type: pageType,
    value: Math.round(metric.value * (metric.name === "CLS" ? 1000 : 1)), non_interaction: true };
}
